import { render } from "./tabs.vue?vue&type=template&id=6ba5d60a&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=6ba5d60a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba5d60a"]])

export default __exports__